<template>
  <div class="container">
    <div class="row">
      <div v-if="loading">
        <loader></loader>
      </div>
      <div v-else>
        <div class="form-group">
          <label for="name">Nome</label>
          <input id="name" type="text" v-model="role.description" class="form-control">
        </div>
        <div class="form-group">
          <label for="name">Grupos Filhos</label>
          <multiselect v-model="value" label="description" track-by='objectId' 
            :multiple="true"
            :show-labels="false" 
            :allow-empty="false" 
            :options="options"  placeholder="Selecione um ou mais grupos" />
        </div>
        <div class="row">
          <div class="col-xs-5">
            <label>Usuários Diponíveis</label>
            <input class="form-control" v-model="filter" placeholder="Filtrar" @keyup.enter="getAdditionalInfo"/>
            <select v-model="leftSelected" class="form-control" size="10" multiple>
              <option v-for="user in users" :value="user">{{user.name}} (<span v-if="user.username">{{user.username}}</span><span v-else>&ltSem Identificação&gt</span>)</option>
            </select>
          </div>
          <div class="col-xs-2">
            <ul class="picklist-control">
              <li>
                <button class="btn btn-primary" @click="addSelected()" title="Adicionar selecionados">
                  <span class="glyphicon glyphicon-forward"></span>
                </button>
              </li>
              <li>
                <button class="btn btn-primary" @click="addAll()" title="Adicionar todos">
                  <span class="glyphicon glyphicon-fast-forward"></span>
                </button>
              </li>
              <li>
                <button class="btn btn-primary" @click="removeSelected()" title="Remover selecionados">
                  <span class="glyphicon glyphicon-backward"></span>
                </button>
              </li>
              <li>
                <button class="btn btn-primary" @click="removeAll()" title="Remover todos">
                  <span class="glyphicon glyphicon-fast-backward"></span>
                </button>
              </li>
            </ul>
          </div>
          <div class="col-xs-5">
            <label>Usuários Vinculados</label>
            <input class="form-control" v-model="filterFinal" placeholder="Filtrar" @keyup.enter="getRoleAndAdditionalInfo(id)"/>            
            <select v-model="rightSelected" class="form-control" size="10" multiple>
              <option v-for="user in finalUsers" :value="user">{{user.name}} (<span v-if="user.username">{{user.username}}</span><span v-else>&ltSem Identificação&gt</span>)</option>
            </select>
          </div>
        </div>
        <br/>
        <button class="btn btn-primary" @click="save">
          Salvar
        </button>
        <button v-if="role.objectId" class="btn btn-danger" @click="remove">
          Excluir
        </button>
        <router-link class="btn btn-default" to="/groups">Cancelar</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    Parse,
    miniToastr
  } from '../Global'

  import Loader from './util/Loader'
  import Multiselect from 'vue-multiselect'
  import { randomBytes } from 'crypto'
  import { handleParseError } from './util/ErrorHandling'

  export default {
    components: {
      Loader,
      Multiselect
    },
    data () {
      return {
        role: {},
        roleParse: null,
        loading: false,
        value: null,
        options: [],
        leftSelected: [],
        rightSelected: [],
        users: [],
        finalUsers: []
      }
    },
    mounted () {
      this.loading = true
      let id = this.$route.params.id
      if (id) {
        this.getRoleAndAdditionalInfo(id)
      } else {
        this.getAdditionalInfo()
      }
    },
    methods: {
      getRoleAndAdditionalInfo (id) {
        let self = this
        self.loading = true
        if (!id) {
          id = this.$route.params.id
        }
        let params = {
          id: id,
          filter: self.filter,
          filterFinal: self.filterFinal
        }
        Parse.Cloud.run('getRoleAndAdditionalInfoGroup', params).then(response => {
          self.users = response.users
          self.finalUsers = response.finalUsers
          self.options = response.options
          self.roleParse = response.roleParse
          self.role = response.role
          self.value = response.value
          self.loading = false
        }, error => {
          self.loading = false
          handleParseError(self, error)
        })
      },
      getAdditionalInfo () {
        let self = this
        self.loading = true
        let params = {
          filter: self.filter
        }
        Parse.Cloud.run('getAdditionalInfoGroup', params).then(response => {
          self.users = response.users
          self.options = response.options
          self.loading = false
        }, error => {
          self.loading = false
          handleParseError(self, error)
        })
      },
      save () {
        let self = this
        if (!self.role.description) {
          miniToastr.warn('Informe o nome do Grupo.')
          return
        }
        let roleParseId
        if (self.roleParse) {
          roleParseId = self.roleParse.id
        }
        let params = {
          objectId: roleParseId,
          roleDescription: self.role.description,
          value: self.value,
          finalUsers: self.finalUsers,
          newObjectId: self.newObjectId()
        }
        Parse.Cloud.run('saveListUsers', params).then(() => {
          miniToastr.success('Salvo com sucesso')
          self.$router.go(-1)
        }, error => {
          handleParseError(self, error)
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      remove () {
        let self = this
        let params = {
          objectId: self.role.objectId
        }
        Parse.Cloud.run('removeGroup', params).then(() => {
          miniToastr.success('Grupo excluído com sucesso')
          self.$router.go(-1)
        }, error => {
          handleParseError(self, error)
        })
      },
      addSelected () {
        this.leftSelected.forEach(user => {
          this.finalUsers.push(user)
          let index = this.users.indexOf(user)
          if (index >= 0) {
            this.users.splice(index, 1)
          }
        })
        this.leftSelected = []
        this.finalUsers.sort(this.sortComparator)
      },
      removeSelected () {
        this.rightSelected.forEach(user => {
          this.users.push(user)
          let index = this.finalUsers.indexOf(user)
          if (index >= 0) {
            this.finalUsers.splice(index, 1)
          }
        })
        this.rightSelected = []
        this.users.sort(this.sortComparator)
      },
      addAll () {
        this.users.forEach(user => {
          this.finalUsers.push(user)
        })
        this.users = []
        this.finalUsers.sort(this.sortComparator)
      },
      removeAll () {
        this.finalUsers.forEach(user => {
          this.users.push(user)
        })
        this.finalUsers = []
        this.users.sort(this.sortComparator)
      },
      sortComparator (a, b) {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      },
      newObjectId () {
        const chars = ('ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
                    'abcdefghijklmnopqrstuvwxyz' +
                    '0123456789')
        let objectId = ''
        const bytes = randomBytes(10)
        for (let i = 0; i < bytes.length; ++i) {
          objectId += chars[bytes.readUInt8(i) % chars.length]
        }
        return objectId
      }
    }
  }
</script>

<style lang="css">
.picklist-control {
  list-style-type:none;
  padding: 20px 0 0;
  margin: 0 auto;
  text-align: center;
}
.picklist-control li {
  margin: 3px;
}
.picklist-control li button {
  width: 40px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// GroupDetail.vue?6c8b4e44